export default "__VITE_ASSET__DSllauJ6__"